import type { EventOrganizerType } from '@/types'
import axios from './axios'

const path = `event-organizer-types`
export async function getEventOrganizerTypeById(id: number, partitionKey: string) {
    const { data } = await axios.get<EventOrganizerType>(`${path}/${partitionKey}/${id}`)
    return data
}
export async function getAllEventOrganizerTypes() {
    const { data } = await axios.get<EventOrganizerType[]>(`${path}`)
    return data
}
